module.exports = __webpack_public_path__ + "395d0c12614a66b90f28d7906a4c29b9.svg";


//////////////////
// WEBPACK FOOTER
// ./components/dashboard/settings/company/check.svg
// module id = 836
// module chunks = 0